'use client';

import { Button } from '../../../components/button';
import { MetaDefault } from '../../../components/typography';
import { HStack } from '@terra/ui-styled-system';
import type { ReactNode } from 'react';
import { AgentStatusDots } from './AgentStatusDots';
import type { ParallelAgentStatus } from './parallel-agent-batch';

export const AGENT_ACTIVITY_PILL_HEIGHT = '22px';

export function AgentActivityPill({
  status,
  label,
  detail,
  trailing,
  title,
  testId,
  state,
  isExpanded,
  isLeaving = false,
  onClick,
}: {
  status: ParallelAgentStatus;
  label: string;
  detail?: ReactNode;
  trailing?: ReactNode;
  title: string;
  testId: string;
  state: string;
  isExpanded: boolean;
  isLeaving?: boolean;
  onClick: () => void;
}) {
  return (
    <Button
      variant="outline"
      size="xs"
      borderRadius="full"
      width="fit-content"
      maxW="full"
      minW={0}
      h={AGENT_ACTIVITY_PILL_HEIGHT}
      minH={AGENT_ACTIVITY_PILL_HEIGHT}
      px={2}
      aria-expanded={isExpanded}
      title={title}
      data-testid={testId}
      data-state={state}
      opacity={isLeaving ? 0 : 1}
      transform={isLeaving ? 'translateY(4px)' : 'translateY(0)'}
      transition="opacity 0.4s ease, transform 0.4s ease"
      animation="fade-in 0.2s ease-out"
      onClick={onClick}
    >
      <HStack gap={1.5} alignItems="center" minW={0}>
        <AgentStatusDots status={status} />
        <MetaDefault color="fg.default" truncate flexShrink={0}>
          {label}
        </MetaDefault>
        {detail}
        {trailing}
      </HStack>
    </Button>
  );
}
